export class CreateApplicationUtilsConstants {
    static DUPLICATE_MESSAGE = "The selected property has already been added";
}
